import { createListCollection, Select } from '@chakra-ui/react';
import { HappyHourDeliveryType } from '@client/graphql/types/graphql';
import { useTranslate } from '@tolgee/react';

export default function DeliveryTypeMultipleSelection(props: {
  deliveryType: HappyHourDeliveryType[];
  onChange: (deliveryType: HappyHourDeliveryType[]) => void;
}) {
  const { t } = useTranslate();

  const deliveryTypeSelection = createListCollection({
    items: [
      {
        label: t(HappyHourDeliveryType.Delivery.toString(), HappyHourDeliveryType.Delivery.toString()),
        value: HappyHourDeliveryType.Delivery,
      },
      {
        label: t(HappyHourDeliveryType.Pickup.toString(), HappyHourDeliveryType.Pickup.toString()),
        value: HappyHourDeliveryType.Pickup,
      },
    ],
  });

  return (
    <Select.Root
      defaultValue={props.deliveryType}
      onValueChange={({ value }) => {
        props.onChange(value as HappyHourDeliveryType[]);
      }}
      border={'solid 1px'}
      borderColor={'gray.300'}
      rounded="sm"
      collection={deliveryTypeSelection}
      multiple
    >
      <Select.HiddenSelect />
      <Select.Control>
        <Select.Trigger>
          <Select.ValueText px={2} placeholder={t('happy-hour.delivery.placeholder', 'Select delivery type')} />
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner>
        <Select.Content>
          {deliveryTypeSelection.items.map((deliveryType) => (
            <Select.Item zIndex={50} item={deliveryType} key={deliveryType.value}>
              {deliveryType.label}
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  );
}
